import BaseModel from './base-model';
/**
 * format:
 */
export default class Status extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.id = opts['@id'] || null;
    this.name = opts['@COMMON_NAME'] || null;
    this.relAttr = opts['@REL_ATTR'] || null;
    this.description = opts.description || null;
    this.zdescripcion_web = opts.zdescripcion_web || null;
    this.webDescription = opts.zdescripcion_web || null;
    if (typeof opts === 'string') {
      this.code = opts;
    }
  }
}
